import { render } from "./ReferralLinksView.vue?vue&type=template&id=942c2816"
import script from "./ReferralLinksView.vue?vue&type=script&lang=js"
export * from "./ReferralLinksView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__